import BaseDrawTool from "./BaseDrawTool";
import {AnnotationsConstants} from "../../../utils/const";
import PentagonOutlinedIcon from "@mui/icons-material/PentagonOutlined";

class Polygon extends BaseDrawTool {

	id = "Polygon";
	name = "Polygon";
	type = "Polygon";
	shape = AnnotationsConstants.POLYGON;
	icon = <PentagonOutlinedIcon/>;
	className = "Polygon-forTour"
	shortcutKey = "6";
}

export default Polygon;
